const styles = theme => ({
  root: {},
  label: {
    color: ['rgba(12,31,44,0.87)', '!important'],
    fontFamily: 'Roboto',
    fontSize: '14px',
    letterSpacing: '0.15px',
    lineHeight: '20px',
    marginRight: theme.spacing.unit
  },
  inputLabel: {
    color: ['rgba(12,31,44,0.6)', '!important'],
    transform: 'translate(12px, 18px) scale(1)'
  },
  formControl: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    marginRight: theme.spacing.unit * 3,
    outline: 'none'
  },
  icon: {
    fontSize: '24px',
    right: 4
  },
  select: {
    // borderRadius: 4,
    padding: [[0, theme.spacing.unit * 4, 0, theme.spacing.unit * 1.75]],
    height: 40,
    backgroundColor: 'transparent',
    '&:focus': {
      backgroundColor: 'transparent'
    },
    marginRight: theme.spacing.unit * 3
  },
  withInputLabel: {
    height: 56,
    boxSizing: 'border-box',
    padding: [
      [
        theme.spacing.unit * 3.375,
        theme.spacing.unit * 4,
        theme.spacing.unit * 1.25,
        theme.spacing.unit * 1.75
      ]
    ],
    width: '100%'
  },
  filterColor: {
    color: theme.palette.primary.main
  },
  font: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    letterSpacing: '0.15px',
    lineHeight: '20px'
  },
  filledInputRoot: {
    borderRadius: '4px',
    backgroundColor: `${theme.palette.primary.light} !important`,
    '&:hover': {
      backgroundColor: `${theme.palette.secondary.light} !important`
    }
  },
  filledInputWithInputLabel: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    minWidth: '120px'
  },
  menuItemRoot: {
    color: 'rgba(12,31,44,0.87)',
    fontFamily: 'Roboto',
    fontSize: '14px',
    letterSpacing: '0.15px',
    lineHeight: '20px',
    backgroundColor: '#FFF !important',
    height: '40px',
    padding: '0 9px',
    '&:hover': {
      backgroundColor: 'whitesmoke !important'
    }
  },
  menuItemSelected: {
    backgroundColor: '#ebebeb !important'
  }
});

export default styles;
